import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';
import { personOutline, settingsOutline, cardOutline, shieldCheckmarkOutline, logOutOutline } from 'ionicons/icons';
import { ReactComponent as SVGTraceLogo } from '../../assets/logo2.svg';
import branding from '../../config/branding';
import { isEmbroideryTrace } from '../../config/appVariant';

import SettingsPage from '../SettingsPage';
import './MobileHeader.css';

const MobileHeader = ({ onAccountClick, isAccountLoading, onSettingsClick, onLogout, onBillingClick }) => {
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [showSettingsPage, setShowSettingsPage] = useState(false);

  return (
    <>
      <div className="mobile-header-bar">
        <div className="mobile-header-logo">
          {isEmbroideryTrace ? (
            <img src={branding.logoDark} alt={branding.appName} className="mobile-header-logo-img" />
          ) : (
            <SVGTraceLogo />
          )}
        </div>
        
        <div className="mobile-header-actions">
          <div style={{ position: 'relative' }}>
            <button 
              className="mobile-header-btn" 
              onClick={() => setShowAccountMenu(!showAccountMenu)}
            >
              <IonIcon icon={personOutline} />
              <span>Account</span>
            </button>
            
            {showAccountMenu && (
              <div 
                className="mobile-account-menu"
                onClick={(e) => e.stopPropagation()}
              >
                {isEmbroideryTrace ? (
                  /* EmbroideryTrace: Billing only, no Settings or Privacy */
                  <div
                    className="mobile-account-menu-item"
                    onClick={() => {
                      setShowAccountMenu(false);
                      if (onBillingClick) onBillingClick();
                    }}
                  >
                    <IonIcon icon={cardOutline} style={{ fontSize: '18px', color: '#F453C4' }} />
                    <span>Billing</span>
                  </div>
                ) : (
                  /* SvgTrace: full account menu */
                  <>
                    <div
                      className="mobile-account-menu-item"
                      onClick={() => {
                        setShowAccountMenu(false);
                        setShowSettingsPage(true);
                      }}
                    >
                      <IonIcon icon={settingsOutline} style={{ fontSize: '18px', color: '#667eea' }} />
                      <span>Settings</span>
                    </div>

                    <div
                      className="mobile-account-menu-item"
                      onClick={() => {
                        setShowAccountMenu(false);
                        if (onBillingClick) onBillingClick();
                      }}
                    >
                      <IonIcon icon={cardOutline} style={{ fontSize: '18px', color: '#F453C4' }} />
                      <span>My Subscription</span>
                    </div>
                    
                    <div
                      className="mobile-account-menu-item"
                      onClick={() => {
                        setShowAccountMenu(false);
                        if (onSettingsClick) onSettingsClick();
                      }}
                    >
                      <IonIcon icon={shieldCheckmarkOutline} style={{ fontSize: '18px', color: '#64748b' }} />
                      <span>Privacy Settings</span>
                    </div>
                  </>
                )}
                
                <div
                  className="mobile-account-menu-item mobile-account-menu-item--danger"
                  onClick={() => {
                    setShowAccountMenu(false);
                    if (onLogout) onLogout();
                  }}
                >
                  <IonIcon icon={logOutOutline} style={{ fontSize: '18px' }} />
                  <span>Log Out</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {showAccountMenu && (
        <div 
          className="mobile-account-backdrop"
          onClick={() => setShowAccountMenu(false)}
        />
      )}

      {/* Full Settings Page Overlay */}
      {showSettingsPage && (
        <div className="settings-overlay" onClick={(e) => { if (e.target === e.currentTarget) setShowSettingsPage(false); }}>
          <SettingsPage onClose={() => setShowSettingsPage(false)} />
        </div>
      )}
    </>
  );
};

export default MobileHeader;
